import React from 'react';

import GenericIconProps from './_icon.type';

export default function ArrowRightLastIcon({ className = 'fill-gray-350' }: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_14319_16513" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14319_16513)">
        <path d="M6.30002 17.3C6.11669 17.1167 6.02502 16.8833 6.02502 16.6C6.02502 16.3167 6.11669 16.0833 6.30002 15.9L10.2 12L6.30002 8.1C6.11669 7.91667 6.02502 7.68333 6.02502 7.4C6.02502 7.11667 6.11669 6.88333 6.30002 6.7C6.48336 6.51667 6.71669 6.425 7.00002 6.425C7.28336 6.425 7.51669 6.51667 7.70002 6.7L12.3 11.3C12.4 11.4 12.4709 11.5083 12.5125 11.625C12.5542 11.7417 12.575 11.8667 12.575 12C12.575 12.1333 12.5542 12.2583 12.5125 12.375C12.4709 12.4917 12.4 12.6 12.3 12.7L7.70002 17.3C7.51669 17.4833 7.28336 17.575 7.00002 17.575C6.71669 17.575 6.48336 17.4833 6.30002 17.3ZM17 18C16.7167 18 16.4792 17.9042 16.2875 17.7125C16.0959 17.5208 16 17.2833 16 17V7C16 6.71667 16.0959 6.47917 16.2875 6.2875C16.4792 6.09583 16.7167 6 17 6C17.2834 6 17.5209 6.09583 17.7125 6.2875C17.9042 6.47917 18 6.71667 18 7V17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5209 17.9042 17.2834 18 17 18Z" />
      </g>
    </svg>
  );
}
